module.exports = __webpack_public_path__ + "media/images/inst-icon-fc49f6543a954037845557bb2899b17f.png";